import React from 'react'
import PropTypes from 'prop-types'
import I18n from 'i18n'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

const FitbitReconnectBanner = ({ onReconnect, onDismiss, className, testId }) => (
  <div
    className={`timeline-card fitbit-reconnect-banner ${className}`.trim()}
    data-testid={testId}
    role='alert'
  >
    <div className='fitbit-reconnect-banner__icon'>
      <FontAwesomeIcon icon='exclamation-triangle' size='2x' />
    </div>
    <div className='fitbit-reconnect-banner__body'>
      <h2 className='text-l text-heavy fitbit-reconnect-banner__title'>
        {I18n.t('components.integrations.fitbit_reconnect_banner.title')}
      </h2>
      <p className='fitbit-reconnect-banner__description'>
        {I18n.t('components.integrations.fitbit_reconnect_banner.description')}
      </p>
      <div className='fitbit-reconnect-banner__actions'>
        <button
          type='button'
          onClick={onReconnect}
          className='waves-effect waves-light text-primary-color background-primary button-primary text-background-color'
          data-testid={`${testId}-cta`}
        >
          {I18n.t('components.integrations.fitbit_reconnect_banner.reconnect_cta')}
        </button>
      </div>
    </div>
    {onDismiss !== undefined &&
      <button
        type='button'
        onClick={onDismiss}
        className='fitbit-reconnect-banner__dismiss'
        aria-label={I18n.t('components.integrations.fitbit_reconnect_banner.dismiss')}
        data-testid={`${testId}-dismiss`}
      >
        <FontAwesomeIcon icon='times' />
      </button>}
  </div>
)

FitbitReconnectBanner.propTypes = {
  onReconnect: PropTypes.func.isRequired,
  onDismiss: PropTypes.func,
  className: PropTypes.string,
  testId: PropTypes.string
}

FitbitReconnectBanner.defaultProps = {
  className: '',
  testId: 'fitbit-reconnect-banner'
}

export default FitbitReconnectBanner
